<div class="modal-header">
  <h4 class="modal-title">Regenerate</h4>

  <button
    type="button"
    aria-label="Close"
    (click)="activeModal.dismiss()"
    class="btn-close"></button>
</div>
<div class="modal-body">
  <app-input-form
    [hidePodcastTitle]="true"
    [onlyOneTab]="true"></app-input-form>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="activeModal.dismiss()">
    Cancel
  </button>
  <button class="btn btn-secondary" (click)="regenerate()">Regenerate</button>
</div>
